<template>
  <div
    v-show="isExpand"
    :class="[classes,'is-' + status]"
    class="rt-stateline-item"
  >
    <li
      v-if="direction === 'vertical'"
      class="rt-xpc-stateline-item"
    >
      <div
        :class="['is-' + status]"
        class="rt-stateline-item__left"
      >
        <div
          class="rt-stateline-item__icon"
          :class="computedIconClass"
        >
          <slot name="icon">
            <rt-icon
              v-if="icon===''||icon"
              :name="icon || iconName"
              :size="computedIconSize"
            />
            <div
              v-else
              class="rt-stateline-item__dot"
              :class="computedDotClass"
              :style="computedDotStyle"
            >
              <slot name="text"></slot>
              <slot name="dot-icon"></slot>
            </div>
          </slot>
        </div>
        <div
          v-show="isTailExpand"
          class="rt-xpc-stateline-item__tail"
          :style="computedTailStyle"
        ></div>
      </div>
      <div
        class="rt-stateline-item__right"
      >
        <div
          :class="['is-' + status]"
          class="rt-stateline-item__head"
        >
          <rt-tooltip
            :content="title || tipContent"
            :disabled="!(isTip && title || tipContent)"
            placement="bottom"
          >
            <div
              class="rt-stateline-item__title"
            >
              <slot name="title">
                {{ title }}
              </slot>
            </div>
          </rt-tooltip>
          <div class="rt-stateline-item__time">
            <slot name="time">
              {{ time }}
            </slot>
          </div>
        </div>
        <div
          v-if="isExpand"
          :class="{ 'is-status': isActiveRight }"
          class="rt-stateline-item__content-contaniner"
        >
          <slot v-if="$slots.default" />
          <rt-stateline-content v-else-if="description || $slots.description">
            <slot name="description">
              {{ description }}
            </slot>
          </rt-stateline-content>
        </div>
      </div>
    </li>
    <template v-else>
      <div
        class="rt-stateline-item__head"
      >
        <div
          v-if="!isFirst()"
          :class="{ 'is-active': isActiveLeft }"
          class="rt-stateline-item__line-left"
          :style="computedLeftStyle"
        ></div>
        <div
          :class="computedIconClass"
          class="rt-stateline-item__icon"
        >
          <slot name="icon">
            <rt-icon
              v-if="icon===''|| icon"
              :name="icon || iconName"
              :size="computedIconSize"
            />
            <div
              v-else
              class="rt-stateline-item__dot"
              :class="computedDotClass"
              :style="computedDotStyle"
            >
              <slot name="text"></slot>
              <slot name="dot-icon"></slot>
            </div>
          </slot>
        </div>
        <div
          v-if="!isLast()"
          :class="{ 'is-active': isActiveRight }"
          class="rt-stateline-item__line-right"
          :style="computedRightStyle"
        ></div>
      </div>
      <div
        :class="['is-' + status]"
        class="rt-stateline-item__main"
      >
        <div class="rt-stateline-item__title">
          <slot name="title">
            {{ title }}
          </slot>
        </div>
      </div>
      <div
        :class="{ 'description-status': isActiveRight }"
        class="rt-stateline-item__description"
      >
        <span>{{ description }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import statusIcons from './status-icons';
import RtIcon from '../icon/rtIcon.vue';
import RtStatelineContent from './rtStatelineContent.vue';
import xpcConfig from '../../config';
export default {
  name: 'RtStatelineItem',
  components: { RtIcon, RtStatelineContent },
  props: {
    title: String,
    description: String,
    time: String,
    icon: String,
    iconSize: {
      type: Number,
      default: 24
    },
    // 图标颜色
    iconColor: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      validator: val => {
        return [
          'process', // 正在处理
          'finish', // 已处理
          'error', // 处理失败
          'success', // 处理成功
          'cancel' // 已取消
        ].includes(val);
      }
    },
    // 描边状态戳颜色
    dotColor: {
      type: String,
      default: undefined
    },
    // 状态戳大小
    dotSize: {
      type: Number,
      default: undefined
    }
  },
  data () {
    return {
      isExpand: true,
      isTailExpand: true,
      // 状态轴高度问题
      isLineInterval: 0,
      isTip: false,
      tipContent: ''
    };
  },
  computed: {
    classes () {
      let classList = [];

      const { last } = this;
      if (last) {
        classList.push('is-last');
      }
      return classList;
    },
    iconName () {
      const status = this.status;

      const iconName = statusIcons[status];
      if (this.icon === '') {
        return iconName
      }

      return this.icon;
    },
    isDot () {
      return !this.status && !this.$slots.icon;
    },
    last () {
      const parent = this.$parent;
      return parent.steps[parent.steps.length - 1] === this;
    },
    direction () {
      return this.$parent.direction;
    },
    isActiveLeft () {
      const steps = this.$parent.steps;
      const index = steps.indexOf(this);
      return (index > 0 && index < steps.length + 1 && steps[index] && !!steps[index].status)
    },
    isActiveRight () {
      const steps = this.$parent.steps;
      const index = steps.indexOf(this);
      return (index >= 0 && index < steps.length && steps[index + 1] && !!steps[index + 1].status);
    },
    computedTailStyle () {
      let style = {};
      if (this.dotSize) {
        style.height = `calc(100% - ${this.computedIconSize}px + ${this.isLineInterval}px)`;
      } else {
        style.height = `calc(100% - ${this.computedIconSize}px)`;
      }
      return style;
    },

    computedDotClass () {
      let classList = [];
      if (this.status && this.computedDotColor) {
        classList.push(`rt-stateline-item-status__dot--${this.computedDotColor}`);
      }
      if (!this.border) {
        classList.push(`rt-stateline-item-status-solid__dot`);
        if (this.status && this.computedDotColor) {
          classList.push(`rt-stateline-item-status-solid__dot--${this.computedDotColor}`);
        }
      }
      return classList
    },
    border () {
      return this.$parent.computedBorder;
    },
    computedDotStyle () {
      let style = {};
      if (this.computedDotSize && this.status) {
        style.width = `${this.computedDotSize}px`;
        style.height = `${this.computedDotSize}px`;
      }
      return style;
    },
    computedIconSize () {
      if (this.iconSize === 16 || this.iconSize === 32 || this.iconSize === 40) {
        return (this.icon === '' || this.icon) ? this.iconSize : this.computedDotSize;
      }
      return (this.icon === '' || this.icon) ? 24 : this.computedDotSize;
    },
    computedDotColor () {
      return this.dotColor || xpcConfig.get('stateline.dotColor')
    },
    computedDotSize () {
      return this.dotSize || xpcConfig.get('stateline.dotSize')
    },
    computedIconClass () {
      let classList = [];
      if (this.isDot) {
        classList.push('is-dot')
      }
      if (this.iconColor) {
        classList.push(`rt-stateline-item__icon--${this.iconColor}`);
      }
      return classList;
    },
    computedLeftStyle () {
      let style = {};
      if (this.computedIconSize) {
        style.right = `calc(50% + ${this.computedIconSize / 2}px)`;
      }
      return style
    },
    computedRightStyle () {
      let style = {};
      if (this.computedIconSize) {
        style.left = `calc(50% + ${this.computedIconSize / 2}px)`;
      }
      return style
    }

  },
  beforeCreate () {
    this.$parent.steps.push(this);
  },
  beforeDestroy () {
    const steps = this.$parent.steps;
    const index = steps.indexOf(this);
    if (index >= 0) {
      steps.splice(index, 1);
    }
  },
  mounted () {
    if (this.direction === 'vertical') {
      let headHeight = this.$el.querySelector('.rt-stateline-item__head').getBoundingClientRect().height;
      let tailEl = this.$el.querySelector('.rt-xpc-stateline-item__tail');
      let iconEl = this.$el.querySelector('.rt-stateline-item__icon');
      tailEl.style.top = `${headHeight / 2 + this.computedIconSize / 2}px`
      iconEl.style.top = `${-this.computedIconSize / 2}px`
      iconEl.style.marginTop = `${headHeight / 2}px`
      // 添加白色背景覆盖线条的颜色
      iconEl.style.background = `#fff`
      if (typeof headHeight === 'number') {
        this.isLineInterval = headHeight / 2
      }
      const titleEl = this.$el.querySelector('.rt-stateline-item__title');
      if (titleEl.scrollWidth > titleEl.offsetWidth) {
        this.isTip = true;
        this.tipContent = titleEl.innerText;
      }
    }
  },
  methods: {
    isFirst () {
      const parent = this.$parent;
      return parent.steps[0] === this;
    },
    isLast () {
      const parent = this.$parent;
      return parent.steps[parent.steps.length - 1] === this;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtStatelineItem.vue?7ccb7a5a